import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Container,
  Button,
  ButtonProps,
  styled,
  Typography,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Pagination,
} from "@mui/material";
import ExtraSmallCard from "../../../Shared-ui/SharedComponents/Cards/ExtraSmallCard";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import variables from "../../../assets/styles/variables.module.scss";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import { Model } from "../../../Shared-ui/Types/common";
import { DELETE_MODELS, GET_MODELS, GET_MODELS_LIST, USERS } from "../../../Services/Endpoint";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { useDispatch } from "react-redux";
import MetaInstance from "../../../Services/AxiosInstance/MetaInstance";
import ModelForm from "./form";
import Confirm from "../../../Shared-ui/Types/Confirm";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";


const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  // transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: variables.primaryColor,
    // boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.2)",
    // transform: "translateY(-2px)",
  },
}));



const AdminModels = () => {

  const [dialogOpen, setDialogOpen] = useState(false);
  const [modelList, setModelList] = useState<Model[]>([]);
  const [model, setModel] = useState<Model | null>(null);

  const [totalPage, setTotalPage] = useState(0)
  const [pageSize, setPageSize] = useState<number>(16);
  const [page, setPage] = useState<number>(1);
  const prevPage = useRef<number>(page);
  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false })
  const dispatch = useDispatch()


  useEffect(() => {
    getModelList();
  }, []);


  useEffect(() => {
    if (prevPage.current !== page) {
      getModelList();
      prevPage.current = page;
    }
  }, [page]);

  const getModelList = async () => {
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.get(`${GET_MODELS}?page=${page}&limit=${pageSize}&sort=createdAt`).then(res => res?.data?.detail)
      setModelList(data.response)
      setTotalPage(data.count)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      dispatch(StopLoading())
    }
  }



  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };



  const handleEdit = (model: Model) => {
    setDialogOpen(true);
    setModel(model)
  };

  const deleteModel = async (model: Model) => {
    try {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      dispatch(StartLoading())
      const data = await MetaInstance.delete(`${DELETE_MODELS}?name=${model.name}`).then(res => res?.data?.detail)
      dispatch(ShowSuccess(data.response))
      getModelList()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())

    }
  };


  const confirmDelete = (row: Model) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure want to delete your data? This action cannot be undone.",
      varient: "delete",
      functionName: deleteModel,
      functionParam: row
    })
  }


  const handleCancel = () => {
    setDialogOpen(false)
    getModelList()
    setModel(null);
  };


  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { md: "flex-end", sm: "flex-start" },
            gap: { md: "10px", sm: "0" },
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <Breadcrumb data={[{ name: "Models", path: "" }]} />
        </Box>

        <Box>
          <ColorButton
            variant="contained"
            disableElevation
            startIcon={<AddIcon />}
            size="large"
            sx={{
              textTransform: "capitalize",
              fontWeight: "500",
              whiteSpace: "nowrap",
              borderRadius: { sm: "8px", xs: "4px" },
              height: "40px",
              padding: "8px 16px",
            }}
            onClick={() => setDialogOpen(true)}
          >
            Add Model
          </ColorButton>
        </Box>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xl: "1fr 1fr 1fr 1fr",
            lg: "1fr 1fr 1fr",
            md: "1fr 1fr",
            sm: "1fr",
          },
          gap: 3,
          gridAutoRows: "1fr",
        }}
      >
        {modelList.map((model, index) =>

          <Box
            key={index}
            sx={{
              // transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                // transform: "translateY(-5px)",
                // boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
              },
            }}
          >
            <ExtraSmallCard
              data={model}
              editFun={handleEdit}
              deleteFun={confirmDelete}
              hideEdit={false}
              hideDelete={false}
            />
          </Box>

        )}


      </Box>


      {totalPage > pageSize && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <Pagination
            count={Math.ceil(totalPage / pageSize)}
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
          />
        </Box>
      )}

      <ConfirmPopup details={confirmPopupData} />
      {dialogOpen && (<ModelForm data={model} handleCancel={handleCancel} />)}


    </Container>
  );
};

export default AdminModels;
